import { useAppStore } from '@store'
import { useCallback, useEffect } from 'react'

export function useModeShortcuts() {
  const setMode = useAppStore.use.setMode()
  const isModalOpen = useAppStore.use.isModalOpen()

  const handleModeShortcut = useCallback(
    (e: KeyboardEvent) => {
      // No hacer nada si hay un modal abierto
      if (isModalOpen) return

      // Verificar que Ctrl (o Cmd en Mac) esté presionado
      if (!e.ctrlKey && !e.metaKey) return

      // Prevenir el comportamiento por defecto solo para las teclas que nos interesan
      if (e.key === '3' || e.key === '4' || e.key === '5') {
        e.preventDefault()
      }

      // Cambiar al modo correspondiente
      switch (e.key) {
        case '3':
          setMode('MODE_IDLE')
          break
        case '4':
          setMode('MODE_ALZADOS')
          break
        case '5':
          setMode('MODE_3D_VIEW')
          break
      }
    },
    [isModalOpen, setMode],
  )

  useEffect(() => {
    window.addEventListener('keydown', handleModeShortcut)
    return () => window.removeEventListener('keydown', handleModeShortcut)
  }, [handleModeShortcut])
}
